import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  GlobalMessageService,
  GlobalMessageType,
  HttpErrorHandler,
  HttpResponseStatus,
  Priority
} from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class ForbiddenHandler extends HttpErrorHandler {
  getPriority?(): Priority;

  responseStatus = HttpResponseStatus.BAD_REQUEST;

  constructor(
    protected readonly globalMessageService: GlobalMessageService
  ) {
    super(globalMessageService);
  }

  handleError(request: HttpRequest<any>, errorResponse: HttpErrorResponse) {
    if (request.url.indexOf('assisted-service/customers/search') === -1) {
      if (errorResponse.error.hasOwnProperty('errors')) {
        this.globalMessageService.add(
          errorResponse.error.errors[0].message,
          GlobalMessageType.MSG_TYPE_ERROR
        );
      } else if (
        typeof errorResponse.error?.error === 'string' &&
        errorResponse.error.error.includes('invalid_client') &&
        request.url.includes('/authorizationserver/oauth/revoke')
      ) {
        return;
      } else {
        this.globalMessageService.add(
          errorResponse.error.error,
          GlobalMessageType.MSG_TYPE_ERROR
        );
      }
    }
  }
}
